import Decimal from "decimal.js";
/** PHP-oriented money helpers — avoid float drift (plan/26, plan/31) */
Decimal.set({ precision: 28, rounding: Decimal.ROUND_HALF_UP });
/** Money storage / wire scale — matches DB `decimal(18,2)` (plan/25). */
export const MONEY_SCALE = 2;
/** Qty storage scale — fractions OK; display trims (plan/25). */
export const QTY_SCALE = 4;
export function d(value) {
    return value instanceof Decimal ? value : new Decimal(value);
}
/** Canonical money string for DB / API — always 2 dp. */
export function money(value) {
    return d(value).toFixed(MONEY_SCALE);
}
/** Canonical qty string for DB / API — always QTY_SCALE dp. */
export function qty(value) {
    return d(value).toFixed(QTY_SCALE);
}
/** Display money (same as storage for PHP). */
export function moneyDisplay(value, places = MONEY_SCALE) {
    return d(value).toFixed(places);
}
/**
 * Display qty: whole numbers without decimals; fractions keep needed places
 * (max QTY_SCALE), no trailing zeros.
 */
export function qtyDisplay(value, maxPlaces = QTY_SCALE) {
    const n = d(value);
    if (n.isInteger())
        return n.toFixed(0);
    const fixed = n.toFixed(maxPlaces);
    return fixed.replace(/(\.\d*?)0+$/, "$1").replace(/\.$/, "");
}
/**
 * Split line amount into net + tax.
 * - exclusive: listed = net; tax = net * rate
 * - inclusive: listed = gross; net = gross / (1+rate); tax = gross - net
 */
export function splitTax(input) {
    const listed = d(input.listed);
    const rate = d(input.ratePct).div(100);
    if (rate.isZero()) {
        const z = money(listed);
        return { net: z, tax: money(0), gross: z };
    }
    if (input.mode === "exclusive") {
        const tax = listed.mul(rate);
        return {
            net: money(listed),
            tax: money(tax),
            gross: money(listed.add(tax)),
        };
    }
    const net = listed.div(rate.add(1));
    const tax = listed.sub(net);
    return { net: money(net), tax: money(tax), gross: money(listed) };
}
export function applyDiscountPct(amount, discountPct) {
    const base = d(amount);
    const discount = base.mul(d(discountPct).div(100));
    return {
        discount: money(discount),
        discounted: money(base.sub(discount)),
    };
}
export function exceedsDiscountCap(discountPct, softCapPct) {
    if (softCapPct == null)
        return false;
    return d(discountPct).gt(d(softCapPct));
}
